import {
    ChangeEventHandler,
    FocusEventHandler,
    forwardRef,
    LegacyRef,
    MouseEventHandler,
    MutableRefObject,
    ReactNode,
} from 'react';
import { RefCallBack } from 'react-hook-form/dist/types';
import { FormFeedback, FormGroup, FormGroupProps, Input, Label } from 'reactstrap';
import 'scss/Main.scss';

export type BaseDatePickerInputProps = {
    className?: string;
    value?: string | ReadonlyArray<string> | number | undefined;
    onClick?: MouseEventHandler<HTMLInputElement | HTMLDivElement>;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onFocus?: FocusEventHandler<HTMLInputElement>;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    id?: string;
    disabled?: boolean;
    invalid?: boolean;
    refCallback?: RefCallBack;
    inputRef?: MutableRefObject<HTMLInputElement | HTMLTextAreaElement | null | undefined>;
    invalidMessage?: string;
    isFocus?: boolean;
    inputProps?: {
        name?: string;
        className?: string;
        inputClassName?: string;
        formGroupProps?: FormGroupProps;
        label?: string | JSX.Element;
        labelClassName?: string;
        options?: ReactNode;
        onFocus?: FocusEventHandler<HTMLInputElement>;
        onBlur?: FocusEventHandler<HTMLInputElement>;
        loading?: boolean;
    };
};

const BaseDatePickerInput = forwardRef(function BaseDatePickerInput(
    {
        inputProps,
        onFocus,
        onBlur,
        refCallback,
        inputRef,
        isFocus,
        invalidMessage,
        className,
        ...props
    }: BaseDatePickerInputProps,
    ref: LegacyRef<Input>
): JSX.Element {
    return (
        <FormGroup
            className={`${inputProps?.className ?? ''} base-input`}
            floating
            onClick={(e) => {
                props.onClick && props.onClick(e);
                inputProps?.formGroupProps?.onClick && inputProps?.formGroupProps?.onClick(e);
            }}
        >
            <Input
                ref={ref}
                name={inputProps?.name}
                onFocus={(e) => {
                    onFocus && onFocus(e);
                    inputProps?.onFocus && inputProps?.onFocus(e);
                }}
                onBlur={(e) => {
                    onBlur && onBlur(e);
                    inputProps?.onBlur && inputProps?.onBlur(e);
                }}
                innerRef={(instance) => {
                    refCallback && refCallback(instance);
                    if (inputRef) inputRef.current = instance;
                }}
                className={`${inputProps?.inputClassName ?? ''} ${
                    inputProps?.loading ? `loading` : ''
                }`}
                {...props}
            >
                {inputProps?.options}
            </Input>
            {inputProps?.label && (
                <Label
                    for={props.id}
                    className={`${inputProps?.labelClassName ?? ''} ${
                        props.disabled ? 'disabled' : ''
                    }`}
                >
                    {inputProps?.label}
                </Label>
            )}
            {!isFocus && invalidMessage && (
                <FormFeedback tooltip>{props.invalid && invalidMessage}</FormFeedback>
            )}
        </FormGroup>
    );
});

export default BaseDatePickerInput;
